import { gql } from '@apollo/client';

import { EventRequest, Quote, Event, User } from '../../types';

type EventFields = Pick<
  Event,
  | 'id'
  | 'uuid'
  | 'date'
  | 'type'
  | 'location_line_1'
  | 'location_line_2'
  | 'location_city'
  | 'postcode'
  | 'approximate_location'
  | 'start_time'
  | 'end_time'
  | 'custom_event_name'
  | 'high_demand'
  | 'urgency'
  | 'date_flexible'
  | 'dateFlexibilityNotes'
  | 'isPartnerBooked'
  | 'partnership'
>;

type UserFields = Pick<User, 'firstName' | 'id'>;

export type EventRequestFields = Pick<
  EventRequest,
  | 'id'
  | 'uuid'
  | 'completed'
  | 'close_date'
  | 'category_tier2'
  | 'description'
  | 'budget'
  | 'additional_info'
  | 'item_quantity'
  | 'tags'
  | 'categories_tier2'
  | 'event_request_tags'
  | 'close_stage'
  | 'minPrice'
  | 'maxPrice'
>;

type QuoteFields = Pick<Quote, 'uuid' | 'state' | 'read_timestamp'>;

export type EventRequestWithQuotes = EventRequestFields & {
  quotes: QuoteFields[];
};

export interface EventById {
  event: EventFields & {
    users: UserFields;
    event_requests: Array<
      EventRequestFields & {
        quotes: Array<QuoteFields>;
      } & {
        quote_limited?: boolean;
      }
    >;
  };
}

export const EVENT_BY_ID = gql`
  query customerEvent($filter: CustomerEventFilter!) {
    event: customerEvent(filter: $filter) {
      id
      uuid
      date
      date_flexible
      dateFlexibilityNotes
      type
      location_line_1
      location_line_2
      location_city
      postcode
      approximate_location
      start_time
      end_time
      custom_event_name
      high_demand
      isPartnerBooked
      partnership
      urgency
      users {
        firstName
        id
      }
      event_requests {
        uuid
        id
        completed
        close_date
        close_stage
        category_tier2
        description
        budget
        additional_info {
          courses
          children
          waiters
          water
          crockery
          power
          bar_type
          supplier_setup
        }
        item_quantity
        tags
        categories_tier2 {
          sys_name
          name
          parent
        }
        quotes {
          uuid
          state
          read_timestamp
        }
        event_request_tags {
          tags_event_request_tags_tag_uuidTotags {
            name
            uuid
            root_tags {
              key
            }
          }
        }
        quote_limited
        minPrice
        maxPrice
      }
    }
  }
`;

// Fetches fields only from the event table.
export const EVENT_BY_ID_BASIC_FIELDS = gql`
  query customerEvent($filter: CustomerEventFilter!) {
    event: customerEvent(filter: $filter) {
      approximate_location
      attribution_data_id
      coordinates
      created
      custom_event_name
      date
      description
      end_time
      freshsales_id
      freshsales_stage
      high_demand
      id
      lead_time
      location_city
      location_line_1
      location_line_2
      location_notes
      partnership
      partnership_id
      postcode
      postcode_prefix
      source
      start_time
      source
      state
      supplier_referral
      type
      unread_quotes_email_sent
      upcoming_event_reminder_sent
      updated
      urgency
      user_id
      uuid
    }
  }
`;
